export default "__VITE_PUBLIC_ASSET__c3bd9ff6__"